export default "__VITE_ASSET__DUnycQrW__"